module.exports = __webpack_public_path__ + "static/Sahel-Bold-fda0d00634bfffcaa5c5a7542744a878.eot";